import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

import { AuthProvider } from "react-auth-kit";
import { Notifications } from "react-push-notification";

ReactDOM.render(
  <AuthProvider authType="cookie" authName="_auth" cookieDomain={window.location.hostname}>
    <Notifications />
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </AuthProvider>,
  document.getElementById("root")
);
